import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./FundraiserDashboard.scss";
import backArrow from "../../../Assets/Images/back-arrow.svg";
import { dateUtils } from "../../../Utils/DateFormatter";
import GaugeChart from "react-gauge-chart";
import { FundraiserServices } from "../../../Services/API/fundraisersService";
import { sessionServices } from "../../../Utils/SessionServices";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { formatAmount } from "../../../Utils/constants";

export default function FundraiserDashboard() {
  const { id } = useParams(); //FETCHING THE FUNDRAISER ID FROM URL
  const gid = `gid://shopify/Metaobject/${id}`;
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [campaignObject, setCampaignObject] = useState({});
  const [progressPercent, setProgressPercent] = useState(0);
  const [leaderboard, setLeaderboard] = useState([]);
  const [allParticipants, setAllParticipants] = useState([]);
  const [role, setRole] = useState("");

  useEffect(() => {
    sessionServices
      ?.getSessionStorageItem("role")
      .then((res) => {
        setRole(res);
      })
      .catch((err) => console.log(err));
  }, []);

  const getAllData = async (id) => {
    // FETCH FUNDRAISER DETAILS
    const getSingleFundraiserDetails =
      await FundraiserServices?.getSingleFundraiserDetails(gid);
    setCampaignObject(getSingleFundraiserDetails?.data);
    // CALCULATE THE RAISED PERCENTAGE FOR GAUGE CHART
    let tempPercent =
      (getSingleFundraiserDetails?.data?.raised * 100) /
      getSingleFundraiserDetails?.data?.goal;
    if (tempPercent > 100) {
      tempPercent = 100;
    }
    setProgressPercent(parseFloat(tempPercent) / 100);

    // FETCH PARTICIPANT CONTRIBUTION LEADERBOARD DATA
    const getParticipantLeaderboard =
      await FundraiserServices?.getParticipantLeaderboard(id);
    setLeaderboard(getParticipantLeaderboard?.data);

    // FETCH ALL PARTICIPANTS DATA
    const getAllParticipantsInCampaign =
      await FundraiserServices?.getAllParticipantsByCampaignId(gid);
    setAllParticipants(getAllParticipantsInCampaign?.data);
    setLoader(false);
  };
  useEffect(() => {
    getAllData(id);
  }, [id]);

  const handleEmailTrigger = () => {
    FundraiserServices?.emailTrigger(id)
      .then((res) => {
        toast.success("Email has been sent to all the participants.");
      })
      .catch((err) => {
        toast.success("Something went wrong, try again later");
      });
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div className="Dashboard-container fundraiser-dashboard-page">
        <div className="campaign-header-container">
          <div className="first-section">
            <div className="backArrow-container">
              <img
                src={backArrow}
                onClick={() => navigate("/")}
                alt="Back to home dashboard"
              />
            </div>
            <div className="names-container">
              <div className="title">{campaignObject?.title}</div>
              <div className="location">{campaignObject?.location}</div>
            </div>
          </div>
          <div className="duration-container">{`${dateUtils?.dateToPhrase(
            campaignObject?.start_date
          )} to ${dateUtils?.dateToPhrase(campaignObject?.end_date)}`}</div>
        </div>
        <div className="custom-row-one">
          <div className="funds-info-container">
            <div className="sub-component-heading">Progress</div>
            <div className="progress-info-container">
              <div className="amounts-container">
                <div className="goal-amount">
                  <div className="heading-target">Target</div>
                  <div className="amount">{`${formatAmount(
                    campaignObject?.goal
                  )}`}</div>
                </div>
                <div className="raised-amount">
                  <div className="heading-raised">Raised</div>
                  <div className="amount">{`${formatAmount(
                    campaignObject?.total_raised
                  )}`}</div>
                </div>
              </div>
              <div className="gauge-container">
                <GaugeChart
                  className="gauge-chart"
                  nrOfLevels={30}
                  colors={["#ff6e1d"]}
                  textColor="#FFFFF"
                  arcWidth={0.3}
                  percent={progressPercent}
                  animate={false}
                />
                {/* PROGRESSPERCENT IS THE PERCENTAGE OF THE GOAL RAISED, IT IS CALCULATED IN THE GETALLDATA FUNCTION */}
              </div>
            </div>
          </div>
          <div className="participant-leaderboard-container">
            <div className="sub-component-heading">Leaderboard</div>
            <div className="leaderboard-item-container">
              {/* RENDERING THE PARTICIPANT'S NAME AND CONTRIBUTION SORTED BASED ON THEIR CONTRIBUTION  */}
              {leaderboard?.map((item, i) => {
                return (
                  <div className="leaderboard-item">
                    <div className="name">{`${i + 1}. ${
                      item?.participantFirstName
                    } ${item?.participantLastName}`}</div>
                    <div className="amount">
                      {formatAmount(item?.participantContribution)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="custom-row-two">
          <div className="people-info">
            <div className="info-item">
              <p className="info-label">GSA:</p>
              <p className="info">{`${campaignObject?.gsa_string?.replace(
                " | ",
                " - "
              )}`}</p>
            </div>
            <div className="info-item">
              <p className="info-label">Fundraiser Hero:</p>
              <p className="info">{`${campaignObject?.fundraiser_hero_string?.replace(
                " | ",
                " - "
              )}`}</p>
            </div>
            <div className="info-item">
              <p className="info-label">Team:</p>
              <p className="info">{`${campaignObject?.teams[0]?.title}`}</p>
            </div>
          </div>
          <div className="edit-btn-container">
            {/* REDIRECT TO THE CREATE FUNDRAISER FORM PAGE IN EDIT STATE AND PASSING THE CAMPAIGN OBJECT TO 
                        SET INITIAL VALUES IN THE FORM, ALSO ADDED IS THE PAGE PROP TO REDIRECT BACK TO THE RESPECTIVE PAGE
                        ON CLICK OF BACK BUTTON IN THE FORM PAGE */}
            {campaignObject?.campaign_status !== "COMPLETED" && (
              <Button
                className="edit-fundraiser-btn"
                onClick={() =>
                  navigate("/fundraisers", {
                    state: {
                      action: "edit",
                      data: campaignObject,
                      history: "dash",
                      campaignId: id,
                    },
                  })
                }
              >
                Edit Fundraiser
              </Button>
            )}
          </div>
        </div>
        <div className="custom-row-two email-trigger">
          {/* BUTTON TO MANUALLY TRIGGER EMAIL ALERT TO PARTICIPANTS OF THE FUNDRAISER */}
          <div className="edit-btn-container">
            {role === "ADMIN" &&
              campaignObject?.campaign_status === "ACTIVE" && (
                <Button
                  className="edit-fundraiser-btn"
                  onClick={handleEmailTrigger}
                >
                  Trigger Email
                </Button>
              )}
          </div>
          {role === "ADMIN" && campaignObject?.campaign_status === "ACTIVE" && (
            <div className="people-info">
              <div className="info-item">
                <p className="info">
                  Click the above button to trigger an Email to all the
                  participants involved in this fundraiser.
                </p>
              </div>
            </div>
          )}
        </div>
        <div className="custom-row-three">
          <div className="participants-list-container">
            <div className="sub-component-heading">Participants</div>
            <div className="participants-container">
              {/* RENDERING EACH PARTICIPANT'S NAME */}
              {allParticipants?.map((item) => {
                return (
                  <div className="participant-item">
                    <div className="name">{`${item?.participant_first_name} ${item?.participant_last_name}`}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
